import { Platform } from 'react-native';
import { getCatalogRamSnapshotCache } from './catalogRamSnapshotCache';

/**
 * En web, la búsqueda lee el snapshot en memoria; el write de stock exige fila en SQLite.
 * Si el apply del snapshot falló (o aún no corrió), hidrata el producto desde el cache.
 * @returns true si el producto quedó (o ya estaba) en SQLite.
 */
export async function ensureLocalProductFromWebCache(productId: string): Promise<boolean> {
  if (!productId) return false;
  return !!getCatalogRamSnapshotCache()?.products.some((p) => p.id === productId);
}
